<template>
  <v-layout text-center>
    <v-container>
      <v-layout row>
        <v-flex xs12 sm6 offset-sm3>
          <v-card>
            <v-toolbar color="blue" dark>
              <v-toolbar-title>Mobile Types</v-toolbar-title>
            </v-toolbar>

            <v-list two-line>
              <template v-for="(mobileType, index) in mobileTypes">
                <v-list-tile
                  :key="mobileType.carrier"
                  avatar
                  ripple
                  @click="editMobile(mobileType)"
                >
                  <v-list-tile-content>
                    <v-list-tile-title>{{ mobileType.carrier }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ mobileType.extension }}</v-list-tile-sub-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-icon
                      color="grey lighten-1"
                    >
                      mdi-pencil
                    </v-icon>

                  </v-list-tile-action>

                </v-list-tile>
                <v-divider
                  v-if="index + 1 < mobileTypes.length"
                  :key="index"
                ></v-divider>
              </template>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-btn
      fab
      bottom
      right
      color="blue"
      dark
      fixed
      class="add-button-bottom"
      @click="dialog = !dialog"
    >
      <v-icon>add</v-icon>
    </v-btn>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card >
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="dialog = !dialog">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title v-if="mobile.id">Edit Mobile Type</v-toolbar-title>
          <v-toolbar-title v-else>Add Mobile Type</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn v-if="mobile.id > 0" dark flat @click="updateMobile">Update</v-btn>
            <v-btn v-else dark flat @click="saveMobile">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout class="pb-3" row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="mobile.carrier"
                  label="Carrier"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="mobile.extension"
                  label="Extension"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'

export default {
  data: () => ({
    currentPage: 'Settings',
    userId: 0,
    dialog: false,
    // myId: this.$store.state.user.id,
    isAdmin: false,
    mobileTypes: [],
    mobile: {},
    snackbar: {
      show: false,
      color: '',
      message: ''
    }
  }),

  created () {
    this.$store.dispatch('setCurrentPage', this.currentPage)
    this.currentYear = this.$store.state.currentYear
    this.isAdmin = this.$store.state.isAdmin
    this.userId = this.$store.state.user.id

    this.getTypes()
  },

  watch: {
    dialog (val) {
      if (!val) {
        this.mobile = {}
      }
    }
  },

  methods: {
    async getTypes () {
      try {
        const response = await Api().get('mobiles')
        this.mobileTypes = response.data
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    editMobile (mobile) {
      this.mobile = mobile
      this.dialog = true
    },

    async saveMobile () {
      try {
        const response = await Api().post('mobiles', this.mobile)

        this.mobileTypes.push(response.data.mobile)

        this.dialog = false
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async updateMobile () {
      try {
        const response = await Api().put('mobiles', this.mobile)

        this.dialog = false
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/settings/MobileTypes.vue